import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
//import PropTypes from 'prop-types';
import {
    Typography
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const useStyles = ({severity}) => makeStyles(theme => ({
    root: {
        // backgroundColor: 'white',
        // color: theme.palette[severity].main,
        // border: `solid 1px ${theme.palette[severity].main}`,
        justifyContent: 'center'
    }
}));

const Message = function({
    children = '',
    severity = 'error'
}) {
    const classes = useStyles({severity})();

    return (
        <Alert severity={severity} className={classes.root}>
            <Typography variant="subtitle1">{children}</Typography>
        </Alert>
    );

};


Message.propTypes = {
};

export default Message;